import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo10 from "../images/short shop.jpg"
import logo11 from "../images/product.jpg"
import logo41 from "../images/assets/logo41.svg"
import logo16 from "../images/assets/logo16.jpeg"
import logo17 from "../images/assets/logo17.jpg"
import logo18 from "../images/assets/logo18.jpg"
import logo19 from "../images/assets/logo19.svg"
import logo20 from "../images/assets/logo20.svg"
import logo21 from "../images/assets/logo21.svg"
import logo22 from "../images/assets/logo22.svg"
import logo23 from "../images/canr.jpg"
import logo24 from "../images/assets/logo24.webp"
import { getAllBranch } from "api/BranchDetailsApi";
import { useNavigate } from 'react-router-dom';

const Findstore = ({ configImages }) => {
  const [data, setData] = useState([]);
  const [selectedList, setSelectedList] = useState({ branchName: "" });
  const [filteredData, setFilteredData] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [filteredStores, setFilteredStores] = useState([]);


  const navigate = useNavigate();

  useEffect(() => {
    const getAllBrachDetails = () => {
      getAllBranch({}).then((data) => {
        setData(data.response.content);
      });
    };
    getAllBrachDetails();
  }, []);

  const handleChange = (e) => {
    const selectedBranch = e.target.value;
    setSelectedList((prev) => ({ ...prev, branchName: selectedBranch }));
    const filteredData = data.filter((item) => item.branchName === selectedBranch);
    setFilteredData(filteredData);
  };


  return (
    <div>
      <div>
        <Link>
          <img style={{ objectFit: "cover", width: "100%", height: "450px" }} src={logo10} />
        </Link>
      </div>

      <div className="container mb-5" style={{ border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "12px", padding: "20px" }}>
        <div className="row">
          
        </div>
        <div className="row">
          <div className="col-6">
            <img style={{ width: "100%", height: "325px", objectFit: "cover" }} src={logo11} />
          </div>
          <div className="col-6">
            {data.length > 0 && (
              <div className="box bg-light position-relative mw-100">
                <div className="box-inner p-0">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.334881880655!2d78.36979007501043!3d17.400971083488596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb950034702ee5%3A0xa9716473decac412!2sSree%20Mayuri%20Silver%20Jewellery%20%7C%20Silver%20jewellery%20store%20in%20Hyderabad!5e1!3m2!1sen!2sin!4v1753955313488!5m2!1sen!2sin"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowfullscreen=""
                    data-lazy="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    title="branch one"
                  ></iframe>
                </div>
              </div>
            )}
            {isChecked && filteredStores.map((store, index) => (
              <div className="box bg-light position-relative mw-100" key={store.id}>
                <div className="box-inner p-0">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.334881880655!2d78.36979007501043!3d17.400971083488596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb950034702ee5%3A0xa9716473decac412!2sSree%20Mayuri%20Silver%20Jewellery%20%7C%20Silver%20jewellery%20store%20in%20Hyderabad!5e1!3m2!1sen!2sin!4v1753955313488!5m2!1sen!2sin"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowfullscreen=""
                    data-lazy="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    title="branch one"
                  ></iframe>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            {filteredData.length > 0 && (
              <div className="card w-100">
                <img src={configImages && configImages.STORIMAGES[configImages.STORIMAGES.length].value} className="card-img-top" alt="Card img" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title text-uppercase">
                    {filteredData[0].storeName}{" "}
                    <small tw="text-sm block py-1 ">
                      {filteredData[0].branchName}
                    </small>
                  </h5>
                  <p className="card-text mb-1">
                    <i className="bi bi-shop" tw="text-custom-100 text-xl mr-2"></i>{" "}
                    {filteredData[0].branchAddress.address1 !== "-" && filteredData[0].branchAddress.address1 + filteredData[0].branchAddress.address2}.
                  </p>
                  <p className="card-text mb-1">
                    <i className="bi bi-envelope" tw="text-custom-100 text-xl mr-2"></i>{" "}
                    {filteredData[0].email}
                  </p>
                  <p className="card-text mb-1">
                    <i className="bi bi-joystick" tw="text-custom-100 text-xl mr-2"></i>{" "}
                    {filteredData[0].branchAddress.districtName} -{" "}
                    {filteredData[0].branchAddress.pincodeNumber}
                  </p>
                  <p className="card-text mb-1">
                    <i className="bi bi-telephone" tw="text-custom-100 text-xl mr-2"></i>{" "}
                    {filteredData[0].countryCode} {filteredData[0].mobile}
                  </p>
                </div>
              </div>
            )}
          </div>
         
        </div>
      </div>
    </div>


  )
}

export default Findstore